import { render, staticRenderFns } from "./aside.vue?vue&type=template&id=7e8ad8e8&scoped=true&"
import script from "./aside.vue?vue&type=script&lang=js&"
export * from "./aside.vue?vue&type=script&lang=js&"
import style0 from "./aside.vue?vue&type=style&index=0&id=7e8ad8e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8ad8e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmtkpv/Projects/barcode-editor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7e8ad8e8', component.options)
    } else {
      api.reload('7e8ad8e8', component.options)
    }
    module.hot.accept("./aside.vue?vue&type=template&id=7e8ad8e8&scoped=true&", function () {
      api.rerender('7e8ad8e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/routes/template/aside.vue"
export default component.exports